import React from 'react';
import { exportCSV, exportPNG, exportSVG } from '../utils/export';

// Compact per-plot export bar — sits directly below a single chart and
// emits CSV / PNG / SVG of just that chart's data and SVG.
//
// Props:
//   chartId       — DOM id of the wrapper div whose first <svg> is exported
//   csvData       — array of plain objects (one row per CSV line)
//   csvFilename   — base name (no extension) for the CSV download
//   plotFilename  — base name for PNG / SVG downloads
//   c             — themeColors(theme) result for button styling
//   disabled      — set to true when no data is ready (greys out CSV/PNG)
export default function PlotExportBar({
  chartId, csvData, csvFilename, plotFilename, c, disabled = false,
  delayMs = 0,
}) {
  const noCSV = disabled || !Array.isArray(csvData) || csvData.length === 0;
  const noPlot = disabled;
  const deferred = (fn) => () => {
    if (delayMs > 0) setTimeout(fn, delayMs);
    else fn();
  };

  const btn = (active) => ({
    padding: '3px 10px',
    fontSize: 11,
    background: c.btnSecondary,
    color: c.btnSecondaryText,
    border: `1px solid ${c.border}`,
    borderRadius: 4,
    cursor: active ? 'pointer' : 'not-allowed',
    opacity: active ? 1 : 0.45,
    fontFamily: 'IBM Plex Mono, monospace',
  });

  return (
    <div style={{
      display: 'flex', gap: 6, justifyContent: 'flex-end',
      padding: '4px 0 8px',
      borderBottom: `1px solid ${c.border}`,
      marginBottom: 12,
    }}>
      <button
        onClick={deferred(() => { if (!noCSV) exportCSV(csvData, csvFilename); })}
        disabled={noCSV}
        style={btn(!noCSV)}>
        📊 CSV
      </button>
      <button
        onClick={deferred(() => { if (!noPlot) exportPNG(chartId, plotFilename); })}
        disabled={noPlot}
        style={btn(!noPlot)}>
        🖼 PNG
      </button>
      <button
        onClick={deferred(() => { if (!noPlot) exportSVG(chartId, plotFilename); })}
        disabled={noPlot}
        style={btn(!noPlot)}>
        📈 SVG
      </button>
    </div>
  );
}
